import React, { useState, useEffect, useMemo } from 'react';
import { Box, LinearProgress } from '@mui/joy';
import { Text } from '../Typography';
import { Icon } from '../../assets';
import ReactApexChart from 'react-apexcharts';
import { useDataProvider } from '../../../mtska-frontend-data-provider';
import { useFormatter } from '../../utils';

const Timeline = ({ title, dataProviderName, icon, filters, format, handleFilterChange }) => {
    const { items, loadAll, loading, reloadCounter } = useDataProvider(dataProviderName);
    const { formatCurrency } = useFormatter();

    useEffect(() => {
        if (dataProviderName && !loading) loadAll(filters);
    }, [filters, reloadCounter]);

    const applyFormat = useMemo(() => {
        return (val) => {
            switch (format) {
                case 'currency':
                    return formatCurrency(val);
                default:
                    return val;
            }
        };
    }, [format, formatCurrency]);

    const series = useMemo(() => {
        if (items && typeof items === 'object' && !Array.isArray(items)) {
            return [{
                name: title,
                data: items.series
            }];
        }
        return null;
    }, [items, title]);

    const options = useMemo(() => {
        if (!items || !items.labels) return null;

        return {
            chart: {
                height: 350,
                type: 'bar',
                toolbar: { show: false },
                events: {
                    dataPointSelection: (event, chartContext, config) => {
                        const clickedBarIndex = config.dataPointIndex;
                        const label = config.w.globals.labels[clickedBarIndex];

                        if (handleFilterChange) {
                            setTimeout(() => handleFilterChange(label), 100)
                        }
                    }
                }
            },
            tooltip: {
                enabled: false
            },
            plotOptions: {
                bar: {
                    borderRadius: 5,
                    dataLabels: { position: 'top' },
                }
            },
            dataLabels: {
                enabled: true,
                formatter: applyFormat,
                offsetY: -20,
                style: {
                    fontSize: '12px',
                    fontWeight: '800',
                    colors: ['#304758']
                }
            },
            xaxis: {
                categories: items.labels,
                labels: { show: true },
                axisBorder: { show: false },
                axisTicks: { show: false },
                tooltip: { enabled: false },
            },
            yaxis: {
                axisBorder: { show: false },
                axisTicks: { show: false },
                labels: { show: false }
            }
        };
    }, [items, applyFormat]);

    return (
        !series || !options ? <LinearProgress /> :
            <Box className="mtska-chart mtska-chart-pie">
                <Icon icon={icon} family="fal" />
                <Text level="title-sm" className="title">{title}</Text>
                <Box className="chartwrapper">
                    <ReactApexChart
                        type="bar"
                        options={options}
                        series={series}
                        height={200}
                    />
                </Box>
            </Box>
    );
};

export default Timeline;
